/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../src/jobiqo/config/jobs');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

module.exports = mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    ALLOWED_JOB_TYPES: ['job_per_template', 'job_per_file'],
    SHOW_EXPIRATION_DATE: true,
    AI: {
      JOB_DESCRIPTION: {
        enabled: true,
      },
    },
    GEO_INFO: {
      fixtures: [
        {
          label: 'Toronto, ON, Canada',
          location: { lat: 43.65107, lng: -79.347015 },
        },
        {
          label: 'Montreal, QC, Canada',
          location: { lat: 45.501690, lng: -73.567253 },
        },
        {
          label: 'Ontario, Canada',
          location: { lat: 51.253777, lng: -85.323212 },
        },
        {
          label: 'QC, Canada',
          location: { lat: 53.860291, lng: -68.425949 },
        },
        {
          label: 'London, ON, Canada',
          location: { lat: 42.984924, lng: -81.245277 },
        },
        {
          label: 'Ottawa, ON, Canada',
          location: { lat: 45.421532, lng: -75.697189 },
        },
      ],
    },
  },
});
